import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes formulaba con intuición… ahora entiendo exactamente qué estoy haciendo.',
  name: 'Camila R.',
  role: 'Buenos Aires'
}, {
  quote: 'Me ayudó muchísimo con neutralización y correcciones. Gané mucha seguridad.',
  name: 'Santiago M.',
  role: 'Córdoba'
}, {
  quote: 'Dejé de improvisar color y mis resultados se volvieron mucho más consistentes.',
  name: 'Luciana G.',
  role: 'Rosario'
}];
export function Testimonials() {
  return <section className="bg-white py-16 px-5" data-id="element-289">
      <div className="max-w-xl mx-auto" data-id="element-290">
        <h2 className="md:text-3xl font-black text-center text-slate-900 mb-12 text-[20px]" data-id="element-291">
          💬 ¿Qué dicen los profesionales que ya usan el sistema?
        </h2>

        <div className="space-y-6" data-id="element-292">
          {testimonials.map((t, i) => <div key={i} className="bg-slate-50 border border-slate-100 p-8 rounded-2xl transition-all hover:bg-white hover:shadow-lg" data-id="element-293">
              <div className="flex gap-1 mb-4" data-id="element-294">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} className="fill-[#C8A96B] text-[#C8A96B]" data-id="element-295" />)}
              </div>
              <p className="text-slate-600 italic text-base mb-6 leading-relaxed font-medium" data-id="element-296">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-297">
                <div className="w-10 h-10 rounded-full bg-[#C8A96B]/10 flex items-center justify-center text-[#C8A96B] font-bold" data-id="element-298">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-299">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-300">{t.name}</p>
                  <p className="text-xs text-slate-400 font-bold uppercase tracking-wider" data-id="element-301">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}